import { Box, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

interface DeviceInstallationSubtitleProps {
  installedCount: number
  notInstalledCount: number
}

const DeviceInstallationSubtitle = ({
  installedCount,
  notInstalledCount,
}: DeviceInstallationSubtitleProps) => {
  const { t } = useTranslation()

  return (
    <Typography variant="caption" color="neutral.600">
      {t("device_installation.SHOWING")}{" "}
      <Box component="span" sx={{ color: "neutral.900", fontWeight: 600 }}>
        {installedCount} {t("device_installation.DEVICES_INSTALLED")}
      </Box>
      {notInstalledCount > 0 && (
        <>
          {" · "}
          {notInstalledCount} {t("device_installation.DEVICES_NOT_INSTALLED")} (
          {t("device_installation.HIDDEN")})
        </>
      )}
    </Typography>
  )
}

export default DeviceInstallationSubtitle
